module.exports = __webpack_public_path__ + "p5_img3.jpg?44ed72b5b65c943331655de540715434";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p5/p5_img3.jpg
// module id = 119
// module chunks = 0